import { Constants } from "@/constants/constants";


const PrivacyPage = () => {
  return (
      <div className="pt-20">
        <section className="bg-gradient-to-br from-white via-sky-50 to-sky-50 py-20">
          <div className="max-w-3xl mx-auto prose prose-neutral">
            <p className="text-muted-foreground leading-relaxed mb-8">
              Last updated: May 1, 2026
            </p>

            <div className="space-y-8">
              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Introduction
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  {Constants.SITE_NAME} (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;) is committed to protecting 
                  your privacy. This Privacy Policy explains how we collect, use, disclose, 
                  and safeguard your information when you visit our website or use our services.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Information We Collect
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  We may collect information about you in a variety of ways, including:
                </p>
                <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                  <li>
                    <strong className="text-foreground">Personal Data:</strong> Name, email address, 
                    phone number, and other contact information you provide when filling out forms 
                    or contacting us.
                  </li>
                  <li>
                    <strong className="text-foreground">Usage Data:</strong> Information about how 
                    you interact with our website, including pages visited, time spent, and 
                    referring sources.
                  </li>
                </ul>                
                <p className="text-muted-foreground leading-relaxed mb-4">
                  This information helps us improve our website and customer experience.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  How We Use Your Information
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  We use the information we collect to:
                </p>
                <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                  <li>Respond to inquiries and provide customer support</li>
                  <li>Provide information about our services</li>
                  <li>Improve our website and operations</li>
                  <li>Monitor website performance and security</li>
                  <li>Comply with legal obligations</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Information Sharing
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  We do not sell, trade, or otherwise transfer your personal information to 
                  outside parties except as necessary to provide our services or as required by law. We may 
                  share aggregated, non-personal information for marketing, advertising, or 
                  research purposes.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Data Security
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  We take reasonable administrative, technical, and physical measures to protect personal information from unauthorized access, use, disclosure, alteration, or destruction.
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  While we strive to protect your information, no method of electronic transmission or storage can be guaranteed to be completely secure.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Your Rights
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  Depending on your location, you may have the right to:
                </p>
                <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                  <li>Access the personal information we hold about you</li>
                  <li>Request correction of inaccurate information</li>
                  <li>Request deletion of your personal information</li>
                  <li>Opt out of marketing communications</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Cookies
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Our website may use cookies and similar tracking technologies to enhance 
                  your experience. You can control cookies through your browser settings, 
                  though disabling cookies may affect some website functionality.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Changes to This Policy
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  We may update this Privacy Policy from time to time. We will notify you of 
                  any changes by posting the new Privacy Policy on this page and updating the 
                  &quot;Last updated&quot; date.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Contact Us
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  If you have any questions about this Privacy Policy, please contact us at{" "}
                  <a
                    href={`mailto:${Constants.SITE_EMAIL}`}
                    className="text-primary hover:underline"
                  >
                    {Constants.SITE_EMAIL}
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
  );
};

export default PrivacyPage;